import { QUERY_RESPONSE_RECEIVED } from '@web-platform/shared-universal-constants/src/network';
import { MICHELIN_HOTEL_FILTER_CHANGED } from '@web-platform/shared-universal-redux/src/actions/michelin';
import {
  MICHELIN_GET_HOTEL_CARHIRE_CREATE_SEARCH,
  MICHELIN_GET_HOTEL_CARHIRE_POLLING,
} from '@web-platform/shared-universal-types/src/network/requestTypes';

import { USER_REQUESTED_SEARCH } from '../../../../actions/searchControls';

import type { Action } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { PollingSessionState } from '@web-platform/shared-universal-types/src/redux/banana/state/shared/michelin/michelin';

export const INITIAL_STATE: PollingSessionState = {
  id: '',
  token: '',
  complete: false,
};

export default (
  state: PollingSessionState = INITIAL_STATE,
  action: Action,
): PollingSessionState => {
  switch (action.type) {
    case QUERY_RESPONSE_RECEIVED: {
      const { payload } = action;

      if (
        payload.type === MICHELIN_GET_HOTEL_CARHIRE_CREATE_SEARCH &&
        payload.response?.body &&
        typeof payload.response.body === 'object' &&
        'pollingSession' in payload.response.body
      ) {
        return {
          id: payload.response.body.pollingSession?.token || '',
          token: payload.response.body.pollingSession?.token || '',
          complete: payload.response.body.pollingSession?.complete || false,
        };
      }

      if (
        payload.type === MICHELIN_GET_HOTEL_CARHIRE_POLLING &&
        payload.response?.body &&
        typeof payload.response.body === 'object' &&
        'pollingSession' in payload.response.body
      ) {
        return {
          ...state,
          token: payload.response.body.pollingSession?.token || '',
          complete: payload.response.body.pollingSession?.complete || false,
        };
      }

      return state;
    }

    case MICHELIN_HOTEL_FILTER_CHANGED: {
      return INITIAL_STATE;
    }

    case USER_REQUESTED_SEARCH: {
      const { payload } = action;
      if (payload.searched) {
        return INITIAL_STATE;
      }
      return state;
    }

    default:
      return state;
  }
};

export const get = (state: PollingSessionState): PollingSessionState => state;
